
import AV from "leancloud-storage";
import { User } from "@/models";
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "LogInBySmsCode",
created() { },
props: {},
data() {
return {
phone: null,
code: null,
countDown: null,
sendSmsTimer: null
};
},
metaInfo() {
return {
title: "登录",
};
},
methods: {
async sendSmsCode() {
let phone = (this.phone || "").trim();

if (phone == "") {
this.$vux.toast.text("手机号不能为空", "middle");
return;
}

let exist = await User.checkPhoneExist(phone);
console.log(exist);
if (!exist) {
this.$vux.toast.text("该手机号尚未注册", "middle");
return;
}

try {
var captcha = new TencentCaptcha('198762067', async (res) => {
console.log(res)

let ticket = res.ticket
let randstr = res.randstr

try {
await AV.Cloud.run(
"sendSMSCodeViaTencentCloudCaptchaVerification",
{ ticket, randstr, mobilePhone: phone, client: "web", action: "logIn" }
)
} catch (err) {
console.log(err)
this.$vux.toast.text("图形码验证失败", "middle");
return
}

this.$vux.toast.text("短信验证码发送成功", "middle");

this.$nextTick(() => {
this.$refs.code.focus()
})

this.setupSmsTimer()
})
captcha.show()
} catch (err) {
console.log(err)
}
},

async logIn() {
if (!this.phone) {
this.$vux.toast.text("手机号不能为空", "middle");
return;
}

if (!this.code) {
this.$vux.toast.text("验证码不能为空", "middle");
return;
}

try {
let sessionToken = await AV.Cloud.run(
"verifySMSCodeAndLogIn",
{ mobilePhone: this.phone, code: this.code, client: "web" }
)

let user = await User.become(sessionToken)
this.$store.commit("logIn", user.toJSON());
this.$router.push({ path: this.from || "/" });
} catch (err) {
this.$vux.toast.text("无效的验证码", "middle");
}
},

setupSmsTimer() {
this.countDown = 60;
this.sendSmsTimer = setInterval(() => {
this.countDown -= 1;
if (this.countDown <= 0 && this.sendSmsTimer) {
clearInterval(this.sendSmsTimer);
this.sendSmsTimer = null;
}
}, 1000);
},

signUp: function () {
this.$router.push({ name: "signUp", query: { from: this.from } });
},
},

computed: {
canSendSms() {
return !this.sendSmsTimer && this.phone && this.phone.length == 11;
},

sendSmsButtonTitle() {
return this.sendSmsTimer ? `${this.countDown} 秒` : "发送验证码";
},
},
components: {
XInput,
Group,
XButton,
},
};



// WEBPACK FOOTER //
// ./src/pages/account/LogInBySmsCode.vue